import { getAppStore } from '../../app/AppStore';
import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { userCanRunSchedule } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { AppState } from '../../app/state/AppState';
import { hasRunNowPermission } from '../../app/utils/MixedContentHelpers';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleRunNow } from './ScheduleMenuActions';

export const ScheduleRunNowAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.SchedulesRunNow,
  translateName: Messages.runNow_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanRunSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return hasRunNowPermission(getAppStore().getState());
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleRunNow(targetItems)
};
